import { IS_DEVELOPMENT_ENV, IS_PROD_ENV, IS_STAGING_ENV } from '../AppConfig';

export class DevLogger implements IDevLogger {
  enabled = IS_DEVELOPMENT_ENV || IS_STAGING_ENV;

  i(...args: unknown[]): void {
    if (this.enabled) {
      console.group('%cInfo', 'background-color: yellow; color: white');
      console.log(...args);
      console.groupEnd();
    }
  }

  e(...args: unknown[]): void {
    if (this.enabled) {
      console.group('%cError', 'background-color: red; color: white');
      console.log(...args);
      console.groupEnd();
    }
  }

  t(...args: unknown[]): void {
    if (this.enabled) {
      console.group('%cTable', 'background-color: yellow; color: white');
      console.table(...args);
      console.groupEnd();
    }
  }
}

// Define the interface for the public methods of DevLogger
interface IDevLogger {
  enabled: boolean;
  i(...args: unknown[]): void;
  e(...args: unknown[]): void;
  t(...args: unknown[]): void;
}

// Initialize the dev logger
export const initDevLogger = () => {
  if (typeof window !== 'undefined') {
    if (IS_PROD_ENV) {
      window.dev = {
        enabled: false,
        i: () => {},
        e: () => {},
        t: () => {},
      } as IDevLogger;
    } else {
      window.dev = new DevLogger();
    }
  }
};
